import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

// AU Binge Promo - until 31.03.2026
export function useBingeAuPromo({
	title,
	offer,
}: {
	title: MaybeRefOrGetter<TitleDetail>;
	offer?: MaybeRefOrGetter<BuyboxRegularOffer>;
}) {
	const { country } = storeToRefs(useLanguageStore());

	const isBingeAuPromoTitle = computed(() => {
		if (country.value !== 'AU') return false;

		return toValue(title).offers.some(offer => offer.package.shortName === 'bng');
	});

	const bannerAndDisclaimer = computed(() => {
		if (!isBingeAuPromoTitle.value) return null;

		return {
			bannerText: 'Stream titles on BINGE now for $5 for 1 month.',
			disclaimerText: 'New and Returning Customers Only. Offer ends 31 March 2026. No lock in contract.',
		};
	});

	const isBingeAuPromoOffer = computed(() => {
		if (!toValue(offer) || !isBingeAuPromoTitle.value) return false;

		return toValue(offer)?.package.shortName === 'bng';
	});

	return { isBingeAuPromoTitle, bannerAndDisclaimer, isBingeAuPromoOffer };
}
